import Vue from 'vue'
import store from './store'
import VueRouter from 'vue-router'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style

Vue.use(VueRouter)

const router = new VueRouter({
	routes: [
		//首页
		{ 
			path: '/', 
			component: ()=>import('@/views/index'),
			meta:{
				title:'香港七星堂2020下半年12生肖运程'
			}
		},
		//生肖页
		{ path: '/sx', component: ()=>import('@/views/sx')}
	]
})

router.beforeEach(async(to, from, next) => {
	NProgress.start()
	if(to.path == '/sx'){
		let sxArr = store.state.sxArr
		let sexArr = store.state.sexArr
		let sxi = to.query.sxi
		let sxy = to.query.sxy
		let sex = to.query.sex
		document.title = '正在加载：'+sxy+'年'+sexArr[sex]+'命生肖'+sxArr[sxi]+'运程'
	}
	//console.log(to.query)
	if(to.query.sellid){
		store.commit('setSellid',to.query.sellid)
	}

	next()
})

router.afterEach(() => {
	// finish progress bar
	NProgress.done()
	// 返回顶部
	window.scrollTo(0,0)
})

export default router